import { render, staticRenderFns } from "./betteruptimeTicketModal.vue?vue&type=template&id=1fe60004&scoped=true"
import script from "./betteruptimeTicketModal.vue?vue&type=script&lang=js"
export * from "./betteruptimeTicketModal.vue?vue&type=script&lang=js"
import style0 from "./betteruptimeTicketModal.vue?vue&type=style&index=0&id=1fe60004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe60004",
  null
  
)

export default component.exports